import Cookies from 'universal-cookie';
import jwt_decode from 'jwt-decode';
import { DEVICE_TYPE_DESKTOP, DEVICE_TYPE_MOBILE } from '@/config/constants';
import { useEffect, useRef } from 'react';
import { Roles } from '@/config/constants';

export interface ResponseApiClient<T = any> {
    success: boolean;
    data?: T;
    status?: string | number;
    type?: string;
    msg?: string;
}

export const statusCode = {
    success: 'success',
    error: 'error',
    info: 'info'
};

export const registerCookie = (token, expires_in) => {
    const cookies = new Cookies();

    cookies.set('session', token, {
        expires: expires_in,
        path: '/',
        sameSite: 'strict'
    });

    const decoded = jwt_decode(token);

    cookies.set('user', JSON.stringify(decoded), {
        expires: expires_in,
        path: '/',
        sameSite: 'strict'
    });
};

export const decodeArrayBufferResponse = (data) => {
    return decodeURIComponent(escape(String.fromCharCode.apply(null, new Uint8Array(data) as any)));
};

export const stringToArrayBuffer = (str) => {
    const buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
    const bufView = new Uint16Array(buf);
    for (let i = 0, strLen = str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return buf;
};

export const registerUser = (data, expires_in) => {
    const cookies = new Cookies();
    cookies.set('user', data, {
        expires: expires_in,
        path: '/',
        sameSite: 'strict'
    });
};

export const handleResponseError = (e) => {
    if (!e.response || !e.response.data) {
        return {
            status: statusCode.error,
            success: false,
            type: 'info',
            msg: 'Oops aconteceu um erro inesperado'
        };
    }
    const { data } = e.response;
    if (data.errors) {
        return {
            status: statusCode.error,
            success: false,
            type: 'info',
            msg: `Encontramos problemas nos seguintes campos:\n${data.errors.join('\n')}`
        };
    } else {
        if (data.error) {
            if (typeof data.error === 'object') {
                data.error = `${data.error[0].msg}: ${data.error[0].param}`;
            }
        }
        return {
            status: statusCode.error,
            success: false,
            type: 'info',
            msg: data.message || data.error || data
        };
    }
};

export const getSession = () => {
    const cookies = new Cookies();
    return cookies.get('session');
};

export const getAuthenticatedHeader = () => {
    return {
        context: {
            headers: {
                authorization: `Bearer ${getSession()}`
            }
        }
    };
};

export const solveUserAgent = (req) => {
    return (req && req.headers['user-agent']) || (navigator && navigator.userAgent) || '';
};

export const getDeviceType = (userAgent) => {
    const isMobile = Boolean(
        userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i)
    );
    return isMobile ? DEVICE_TYPE_MOBILE : DEVICE_TYPE_DESKTOP;
};

export const useDidMountEffect = (func, deps) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) func();
        else didMount.current = true;
    }, deps);
};

export const getGtmId = () => process.env.GTM_ID;

export const containsRole = (roles, allowed) => {
    return roles?.some((r) => allowed.includes(r));
};

export const hasDropDown = (roles) => {
    if (containsRole(roles, [Roles.ADMIN])) {
        return true;
    }
    let rolesCounter = 0;
    if (containsRole(roles, [Roles.RH, Roles.RH_ADM, Roles.RH_CONDO])) {
        rolesCounter++;
    }
    if (containsRole(roles, [Roles.RESCISSION])) {
        rolesCounter++;
    }

    return rolesCounter > 1;
};
